// removed by extract-text-webpack-plugin
module.exports = {"articleHeaderInfo":"styles__articleHeaderInfo___21mz5"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/articleHeaderInfo/styles.css
// module id = /+pM
// module chunks = 3